import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Task } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  markTaskAsCompleted(
    request: Boundaries["markTaskAsCompleted"]["request"],
  ): void;
}

function useMarkTaskAsCompleted(task: Identifiable<Task>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isMarkTaskAsCompletedRequestPending(task),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isMarkTaskAsCompletedRequestSuccess(task),
    ),
    isRequestFailure: useSelector(() =>
      selector.isMarkTaskAsCompletedRequestFailure(task),
    ),
    markTaskAsCompleted: core.markTaskAsCompleted,
  };
}

export { useMarkTaskAsCompleted };
